var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17043",
    "data-name": "Group 17043",
    transform: "translate(-16 -28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_11988",
    "data-name": "Path 11988",
    transform: "translate(16 28)",
    fill: "#ec6321"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 17 C 4.588789939880371 17 1 13.41121006011963 1 9 C 1 4.588789939880371 4.588789939880371 1 9 1 C 13.41121006011963 1 17 4.588789939880371 17 9 C 17 13.41121006011963 13.41121006011963 17 9 17 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 2 C 5.140190124511719 2 2 5.140190124511719 2 9 C 2 12.85980987548828 5.140190124511719 16 9 16 C 12.85980987548828 16 16 12.85980987548828 16 9 C 16 5.140190124511719 12.85980987548828 2 9 2 M 9 0 C 13.97056007385254 0 18 4.029439926147461 18 9 C 18 13.97056007385254 13.97056007385254 18 9 18 C 4.029439926147461 18 0 13.97056007385254 0 9 C 0 4.029439926147461 4.029439926147461 0 9 0 Z",
    stroke: "none",
    fill: "#ec6321"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M15.971,9.769l-5.154,5.176h0a.7.7,0,0,1-.447.212.675.675,0,0,1-.451-.22L7.757,12.779a.154.154,0,0,1,0-.22l.686-.687a.15.15,0,0,1,.216,0l1.711,1.712,4.7-4.737a.151.151,0,0,1,.108-.046h0a.14.14,0,0,1,.108.046l.675.7A.152.152,0,0,1,15.971,9.769Z",
    transform: "translate(13.134 25.015)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon);
export default __webpack_public_path__ + "static/media/check icon.a8c94b939b7c1e18d89cc068c974182c.svg";
export { ForwardRef as ReactComponent };